import React from "react";
import PropTypes from 'prop-types'
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import {Tooltip} from "@material-ui/core";

const headCells = [
    {name: 'name', label: "Name", width: 200},
    {name: 'description', label: "Description"},
];

const useStyles = makeStyles(() => ({
    title: {
        width: '90px',
        paddingTop: 10
    },
    tableWrapper: {
        width: 'calc(100% - 100px)'
    },
    table: {
        tableLayout: "fixed"
    },
    tableCell: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        '&[class*="MuiTableCell-sizeSmall"]': {
            padding: '0 24px 0 15px !important',
        },
    },
    tableHead: {
        background: 'rgb(237, 237, 237)'
    }
}));

const DataTable = ({data = [], onChangeAll, onChangeItem, title, basePath, disabled}) => {
    const classes = useStyles();
    const countSelected = data.reduce((acc, value) => {
        return value.active ? acc + 1 : acc
    }, 0);
    const countRows = data.length;
    return (
        <>
            <div className={classes.title}>
                <Typography color={"textSecondary"} style={{fontSize: '0.9rem'}}>{title}</Typography>
            </div>
            <div className={classes.tableWrapper}>
                <Table size={"small"} className={classes.table}>
                    <caption style={{display: Boolean(countRows) ? 'none' : 'block'}}>No data</caption>
                    <TableHead className={classes.tableHead}>
                        <TableRow>
                            <TableCell style={{width: 40}}>
                                <Checkbox
                                    indeterminate={countSelected > 0 && countSelected < countRows}
                                    checked={countRows === countSelected && countRows !== 0}
                                    disabled={!Boolean(countRows) || disabled}
                                    onChange={(e) => onChangeAll(e.target.checked, basePath)}
                                    style={{padding: '1px'}}
                                    color={"primary"}
                                />
                            </TableCell>
                            {headCells.map(cell => (
                                <TableCell key={cell.name} style={{width: cell.width}}>
                                    {cell.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((item, index) => (
                            <Tooltip title={item.implClass} key={index}>
                                <TableRow>
                                    <TableCell className={classes.tableCell}>
                                        <Checkbox
                                            disabled={!Boolean(countRows) || disabled}
                                            checked={item.active}
                                            onChange={() => onChangeItem(!item.active, `${basePath}.${index}.active`)}
                                            color={"primary"}
                                            style={{padding: '2px'}}
                                        />
                                    </TableCell>
                                    {headCells.map(cell => (
                                        <TableCell className={classes.tableCell} key={cell.name}>
                                            {item[cell.name]}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </Tooltip>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </>
    )
};

export default DataTable

DataTable.propTypes = {
    data: PropTypes.array,
    onChangeAll: PropTypes.func,
    onChangeItem: PropTypes.func,
    title: PropTypes.string,
    basePath: PropTypes.string,
    disabled: PropTypes.bool
};

DataTable.defaultProps = {
    data: []
};